import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import { css, cx } from "emotion";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import MaskedInput from "react-text-mask";
import { alert } from "../../../components/AlertDialog";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputImage from "../../../components/InputImage";
import InputSelectSearch from "../../../components/InputSelectSearch";
import {
  createMaskInput,
  formatCurrency,
  formatDB,
} from "../../../components/Utils/Currency";
import CategoryService from "../../../Services/Category/CategoryService";
import InvoiceService from "../../../Services/InvoiceService";
import categoryStore from "../../../Store/CategoryStore";
import tenantStore from "../../../Store/TenantStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

function Form(props) {
  const user = JSON.parse(localStorage.getItem("user")) || "";
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [optionsCategory, setOptionsCategory] = React.useState([]);
  const [optionsBank, setOptionsBank] = React.useState([]);
  const [categoryState, categoryActions] = categoryStore();
  const [tenantState, tenantActions] = tenantStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      category: "",
      tenant_type: "",
      service_charge_percentage: 0,
      tax_charge_percentage: 0,
      email: "",
      logo: {
        square: "",
        rectangle: "",
      },
      bank_code: "",
      bank_account_name: "",
      bank_account_number: "",
      open_st: true,
      // tenatType: "",
      floor: "",
    },
  });
  console.log(state);
  const [componentWillMount] = React.useState(false);

  const asyncGetOptionsCategory = (query) => {
    return new Promise((resolve, reject) => {
      CategoryService.getData({
        type: "tenant",
        property_id:
          user?.type === "staff" && user?.operational?.level === 1
            ? user?.operational?.id
            : state.formData.property
            ? state.formData.property
            : 0,
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsCategory(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const asyncGetOptionsBank = (query) => {
    return new Promise((resolve, reject) => {
      InvoiceService.getListBank({
        keyword: query,
      })
        .then((response) => {
          const listOptions = response?.map((row) => ({
            value: row?.bank_code || "",
            name: row?.bank_name || "",
          }));
          setOptionsBank(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadDataRelation = () => {
    setLoading(true);
    const categoryName = data ? data?.category?.name : "";
    const bankCode = data ? data?.bank_code : "";
    Promise.all([
      asyncGetOptionsCategory(categoryName),
      asyncGetOptionsBank(bankCode),
    ]).then(() => {
      setLoading(false);
    });
  };

  React.useEffect(() => {
    loadDataRelation();
    if (data) {
      console.log(data);
      setState({
        formData: {
          id: data.id,
          name: data.name,
          // category: data.category.id,
          tenant_type: `${data.tenant_type.id}`,
          service_charge_percentage:
            data.service_charge_percentage !== ""
              ? formatCurrency(
                  process.env.REACT_APP_CURRENCY_CODE,
                  data.service_charge_percentage,
                  true
                )
              : "",
          tax_charge_percentage:
            data.tax_charge_percentage !== ""
              ? formatCurrency(
                  process.env.REACT_APP_CURRENCY_CODE,
                  data.tax_charge_percentage,
                  true
                )
              : "",
          email: data.email,
          logo: data.logo,
          bank_code: data.bank_code,
          bank_account_name: data.bank_account_name,
          bank_account_number: data.bank_account_number,
          open_st: data.open_st,
          floor: data.floor || "",
        },
      });
    }
  }, [componentWillMount, categoryActions, data]);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleSubmit = (event) => {
    if (
      state.formData.logo.square === "" ||
      state.formData.logo.rectangle === ""
    ) {
      const arrError = [];

      if (state.formData.logo.square === "") {
        arrError.push("Tenant Logo (Square)");
      }

      if (state.formData.logo.rectangle === "") {
        arrError.push("Tenant Logo (Rectangle)");
      }

      const txtError = arrError.length > 1 ? arrError.join(", ") : arrError[0];

      alert("Warning", `Please upload ${txtError}`);
    } else {
      confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
        if (props.data === null) {
          const { formData } = state;
          formData.tax_charge_percentage =
            formData.tax_charge_percentage !== ""
              ? parseFloat(
                  formatDB(
                    formData.tax_charge_percentage.toString().replace("%", "")
                  )
                )
              : 0;
          formData.service_charge_percentage =
            formData.service_charge_percentage !== ""
              ? parseFloat(
                  formatDB(
                    formData.service_charge_percentage
                      .toString()
                      .replace("%", "")
                  )
                )
              : 0;
          await tenantActions.store(formData);
          handleCloseDialog();
          cancel();
        } else {
          const { formData } = state;
          formData.tax_charge_percentage =
            formData.tax_charge_percentage !== ""
              ? parseFloat(
                  formatDB(
                    formData.tax_charge_percentage.toString().replace("%", "")
                  )
                )
              : 0;
          formData.service_charge_percentage =
            formData.service_charge_percentage !== ""
              ? parseFloat(
                  formatDB(
                    formData.service_charge_percentage
                      .toString()
                      .replace("%", "")
                  )
                )
              : 0;
          await tenantActions.put(formData);
          handleCloseDialog();
          cancel();
        }
      });
    }
  };
  // console.log(">>>>" + state.formData.tenant_type.toString());
  return (
    <CustomizedDialogs
      maxWidth={width !== "xs" ? "sm" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        {loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <ValidatorForm
            id="myform"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Paper className={classes.root} style={{ boxShadow: "none" }}>
              <Grid container>
                <Typography
                  variant="subtitle1"
                  className={classes.header}
                  gutterBottom
                >
                  Input Data Tenant Management
                </Typography>
                <Grid item xs={12}>
                  <TextValidator
                    id="name"
                    label="Tenant Name"
                    name="name"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.name}
                    type="text"
                    inputProps={{ maxLength: 61 }}
                    validators={["required", "maxStringLength:60"]}
                    errorMessages={[
                      "Tenant name is required",
                      "maximum character is 60",
                    ]}
                    onChange={handleChange}
                    autoFocus
                  />

                  {/* <InputSelectSearch
                    value={state.formData.category}
                    options={optionsCategory}
                    getOptions={(query) => asyncGetOptionsCategory(query)}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "category", value: value },
                      })
                    }
                    search
                    closeOnSelect={true}
                    validators={["required"]}
                    errorMessages={["Category is required"]}
                    placeholder="Search for category"
                  /> */}

                  <TextValidator
                    id="email"
                    label="Email"
                    name="email"
                    className={classes.textField}
                    validators={["required", "isEmail", "maxStringLength:100"]}
                    errorMessages={[
                      "Email is required",
                      "Email is not valid",
                      "Maximum character is 100",
                    ]}
                    margin="normal"
                    autoComplete="email"
                    readOnly
                    value={state.formData.email}
                    onChange={handleChange}
                  />
                  <TextValidator
                    id="floor"
                    label="Floor (optional)"
                    name="floor"
                    // type="number"
                    className={classes.textField}
                    // validators={["required", "isNumber"]}
                    // errorMessages={["Floor is required"]}
                    margin="normal"
                    autoComplete="email"
                    readOnly
                    value={state.formData.floor}
                    onChange={handleChange}
                  />
                  <label>Tenant Type</label>
                  <div>
                    <Radio
                      checked={state.formData.tenant_type === "1"}
                      onChange={handleChange}
                      value="1"
                      name="tenant_type"
                      inputProps={{ "aria-label": "1" }}
                    />
                    <label>Shop</label>
                    <Radio
                      checked={state.formData.tenant_type === "2"}
                      onChange={handleChange}
                      value="2"
                      name="tenant_type"
                      inputProps={{ "aria-label": "1" }}
                    />
                    <label>Dine</label>
                  </div>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={cx(
                        classes.header,
                        css`
                          text-align: left !important;
                          margin-top: 16px !important;
                        `
                      )}
                      gutterBottom
                    >
                      Charge Percentage
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <MaskedInput
                      mask={createMaskInput("", " %", true, 3)}
                      id="tax_charge_percentage-masked"
                      placeholder="Tax Charge Percentage"
                      name="tax_charge_percentage"
                      onChange={(e) => {
                        const { formData } = state;
                        formData["tax_charge_percentage"] = e.target.value;
                        setState({ formData });
                      }}
                      style={{ marginTop: 0 }}
                      render={(ref, props) => (
                        <TextValidator
                          inputRef={ref}
                          {...props}
                          value={state.formData.tax_charge_percentage}
                          label="Tax Charge Percentage"
                          className={classes.textField}
                          margin="normal"
                          type="text"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <MaskedInput
                      mask={createMaskInput("", " %", true, 3)}
                      id="service_charge_percentage-masked"
                      placeholder="Service Charge Percentage"
                      name="service_charge_percentage"
                      onChange={(e) => {
                        const { formData } = state;
                        formData["service_charge_percentage"] = e.target.value;
                        setState({ formData });
                      }}
                      style={{ marginTop: 0 }}
                      render={(ref, props) => (
                        <TextValidator
                          inputRef={ref}
                          {...props}
                          value={state.formData.service_charge_percentage}
                          label="Service Charge Percentage"
                          className={classes.textField}
                          margin="normal"
                          type="text"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={cx(
                        classes.header,
                        css`
                          text-align: left !important;
                          margin-top: 16px !important;
                        `
                      )}
                      gutterBottom
                    >
                      Bank Account
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <InputSelectSearch
                      value={state.formData.bank_code}
                      options={optionsBank}
                      getOptions={(query) => asyncGetOptionsBank(query)}
                      onChange={(value) =>
                        handleChange({
                          target: { name: "bank_code", value: value },
                        })
                      }
                      search
                      closeOnSelect={true}
                      validators={["required"]}
                      errorMessages={["Bank Name is required"]}
                      placeholder="Search for Bank Name"
                    />
                    <TextValidator
                      id="bank_account_name"
                      label="Bank Account Name"
                      name="bank_account_name"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.bank_account_name}
                      type="text"
                      validators={["required", "maxStringLength:150"]}
                      errorMessages={[
                        "Bank Account Name is required",
                        "maximum character is 150",
                      ]}
                      onChange={handleChange}
                    />
                    <TextValidator
                      id="bank_account_number"
                      label="Bank Account Number"
                      name="bank_account_number"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.bank_account_number}
                      type="text"
                      validators={[
                        "required",
                        "maxStringLength:150",
                        "matchRegexp:^[0-9]+$",
                      ]}
                      errorMessages={[
                        "Bank Account Number is required",
                        "Maximum character is 150",
                        "Invalid Bank Account Number format (only number allowed)",
                      ]}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={cx(
                        classes.header,
                        css`
                          text-align: center !important;
                          margin-top: 16px !important;
                        `
                      )}
                      gutterBottom
                    >
                      Tenant Logo
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      Square
                    </Typography>
                    <InputImage
                      image={state.formData.logo.square}
                      maxSize={500}
                      aspectW={1}
                      aspectH={1}
                      removeType="reset"
                      onUploadDone={(url) => {
                        const { formData } = state;
                        formData.logo.square = url;
                        setState({ formData });
                      }}
                      onRemove={(url) => {
                        const { formData } = state;
                        formData.logo.square = "";
                        setState({ formData });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      Rectangle
                    </Typography>
                    <InputImage
                      image={state.formData.logo.rectangle}
                      maxSize={500}
                      aspectW={16}
                      aspectH={9}
                      removeType="reset"
                      onUploadDone={(url) => {
                        const { formData } = state;
                        formData.logo.rectangle = url;
                        setState({ formData });
                      }}
                      onRemove={(url) => {
                        const { formData } = state;
                        formData.logo.rectangle = "";
                        setState({ formData });
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </ValidatorForm>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button
            onClick={() => {
              handleCloseDialog();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            form="myform"
            variant="contained"
            style={{ marginRight: 30 }}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      )}
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};

export function submitForm(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
